(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('TrRouteDeleteController',TrRouteDeleteController);

    TrRouteDeleteController.$inject = ['$uibModalInstance', 'entity', 'TrRoute','$scope'];

    function TrRouteDeleteController($uibModalInstance, entity, TrRoute,$scope) {
        var vm = this;

        vm.trRoute = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
        	$scope.deletefail = true;
            TrRoute.delete({id: id},
                function () {
            	
            	 $scope.deletefail = false;
                    $uibModalInstance.close(true);
                });
           
        }
    }
})();
